import { buildVersion } from "@/utils/environment";
import type { AudioContextInterface } from "@/utils/recording";

/**
 * The TUS metadata a voice recording uploads with, tying the WAV to the item published for it and marking it a
 * recording rather than a file, so the pipeline transcribes and plays it as one.
 */
export function recordingUploadMetadata(recording: {
  contentId: string;
  fileType: string;
  stage: string;
  /** The item `publishToWorkspaceFeed` returned for the recording; the upload lands on it. */
  itemId: string | undefined;
  feedId: string;
  accountId: string | undefined;
  durationSeconds: number;
  preferredLanguage: string;
  audio: AudioContextInterface;
}): Record<string, string | undefined> {
  const { contentId, durationSeconds } = recording;
  return {
    filename: contentId,
    filetype: recording.fileType,
    id: contentId,
    codec: "wav",
    type: "audio",
    uploadId: contentId,
    surface: "web",
    surfaceContext: globalThis.navigator?.userAgent,
    surfaceBuild: buildVersion(),
    stage: recording.stage,
    feedItemId: recording.itemId,
    feedId: recording.feedId,
    accountId: recording.accountId,
    duration: durationSeconds ? durationSeconds.toString() : "",
    preferredLanguage: recording.preferredLanguage,
    inputType: "Recording",
    ...recording.audio,
  };
}
